import { render, staticRenderFns } from "./PromotionPreviewButton.vue?vue&type=template&id=6b0cf554&"
import script from "./PromotionPreviewButton.vue?vue&type=script&lang=ts&"
export * from "./PromotionPreviewButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports